import React, { useEffect } from 'react'
import { AnnualRevenue } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'

import GoodFitQuestionContent from '@sputnik/pages/PreApplicationPages/GoodFitSurveyPage/GoodFitWizardForm/GoodFitQuestionContent'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const AnnualRevenueQuestion = () => {
  const annualRevenueOptions = [
    {
      id: AnnualRevenue.LESS_THAN_500K,
      key: AnnualRevenue.LESS_THAN_500K,
      label: (
        <FormattedMessage
          defaultMessage='less than $500k'
          id='sputnik.AnnualRevenueQuestion__BgCIPP'
        />
      ),
      value: AnnualRevenue.LESS_THAN_500K,
    },
    {
      id: AnnualRevenue.BETWEEN_500K_AND_5_MIL,
      key: AnnualRevenue.BETWEEN_500K_AND_5_MIL,
      label: (
        <FormattedMessage
          defaultMessage='$500k-$5m'
          id='sputnik.AnnualRevenueQuestion__BjbQEY'
        />
      ),
      value: AnnualRevenue.BETWEEN_500K_AND_5_MIL,
    },
    {
      id: AnnualRevenue.BETWEEN_5_MIL_AND_10_MIL,
      key: AnnualRevenue.BETWEEN_5_MIL_AND_10_MIL,
      label: (
        <FormattedMessage
          defaultMessage='$5-$10m'
          id='sputnik.AnnualRevenueQuestion__w0CGud'
        />
      ),
      value: AnnualRevenue.BETWEEN_5_MIL_AND_10_MIL,
    },
    {
      id: AnnualRevenue.BETWEEN_10_MIL_AND_20_MIL,
      key: AnnualRevenue.BETWEEN_10_MIL_AND_20_MIL,
      label: (
        <FormattedMessage
          defaultMessage='$10-$20m'
          id='sputnik.AnnualRevenueQuestion__pwcdkt'
        />
      ),
      value: AnnualRevenue.BETWEEN_10_MIL_AND_20_MIL,
    },
    {
      id: AnnualRevenue.OVER_20_MIL,
      key: AnnualRevenue.OVER_20_MIL,
      label: (
        <FormattedMessage
          defaultMessage='$20m+'
          id='sputnik.AnnualRevenueQuestion__piz0wo'
        />
      ),
      value: AnnualRevenue.OVER_20_MIL,
    },
  ]

  const { track } = useWebTracking()

  /* tracking start */

  useEffect(() => {
    track('se_signup__qualification_check_revenue__presented')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* tracking end */

  return (
    <GoodFitQuestionContent
      inputName='annualRevenue'
      options={annualRevenueOptions}
      question={
        <FormattedMessage
          defaultMessage="What's your company's annual revenue?"
          id='sputnik.AnnualRevenueQuestion__jJYt2d'
        />
      }
    />
  )
}

export default AnnualRevenueQuestion
